export enum Roles {
    PortalUserNotBinded = 'PORTAL_USER_NOT_BINDED',
    PortalCustomer = 'PORTAL_CUSTOMER',
  }